import { useQuery } from '@apollo/client/react'
import { BillingTier } from '@zeus/index'
import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { GQL_CAPACITY_ALERT } from '~/gql/billing/billing'
import { neededTierLabel } from '~/helpers/billing/needed-tier'
import { useBranding } from '~/helpers/branding/branding-context'
import { useContactPanel } from '~/helpers/store/contact-panel'

/**
 * Le palier souscrit est dépassé (#355) : rappelé aux admins sur tout le
 * back-office tant que ça dure, en écho au mail. Jamais bloquant. Quand la
 * facturation est masquée (#165), c'est le seul endroit où l'admin le voit, et
 * le changement passe par Studeva.
 */
function CapacityAlertBanner() {
  const { t } = useTranslation()
  const { billingSelfService } = useBranding()
  const openContact = useContactPanel(state => state.open)
  const { data } = useQuery(GQL_CAPACITY_ALERT, { fetchPolicy: 'cache-and-network' })
  const alert = data?.capacityAlert
  if (!alert) return null

  const tier = t(`billing.tier.${alert.tier}`)
  const message = alert.neededTier === BillingTier.CUSTOM
    ? t('billing.overCapacity.quote', { learners: alert.learnerCount, tier })
    : t('billing.overCapacity', { learners: alert.learnerCount, tier, needed: neededTierLabel(t, alert.neededTier as BillingTier) })
  const action = 'w-fit text-left font-medium text-primary-text underline underline-offset-4'

  return (
    <div role="status" className="flex items-start gap-3 rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm">
      <TriangleAlert className="mt-0.5 size-5 shrink-0 text-warning-text" aria-hidden />
      <div className="flex flex-col gap-1">
        <p>{message}</p>
        {billingSelfService
          ? <Link to="/back-office/billing" className={action}>{t('billing.capacityAlert.change')}</Link>
          : <button type="button" onClick={openContact} className={action}>{t('billing.capacityAlert.contact')}</button>}
      </div>
    </div>
  )
}

export default CapacityAlertBanner
